import { render, staticRenderFns } from "./CaseHeaderOptions.vue?vue&type=template&id=1f055436&scoped=true&"
import script from "./CaseHeaderOptions.vue?vue&type=script&lang=js&"
export * from "./CaseHeaderOptions.vue?vue&type=script&lang=js&"
import style0 from "./CaseHeaderOptions.vue?vue&type=style&index=0&id=1f055436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f055436",
  null
  
)

export default component.exports